import { DisplayEnv } from "./DisplayEnv";
import { IEnvironnements } from "./environnements";

export const envTemplate = (option: IEnvironnements) => {
    return <DisplayEnv  code={option?.code} name={option?.name} />;
  };